"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatHashData = formatHashData;
exports.parseHashData = parseHashData;
const separator = "_";
function formatHashData({ commitId, hash }) {
    return `${commitId}${separator}${hash}`;
}
function parseHashData(data) {
    const [rawCommitId, ...hash] = data.split(separator);
    const commitId = parseInt(rawCommitId);
    if (!hash || !commitId || Number.isNaN(commitId)) {
        return null;
    }
    return { commitId, hash: hash.join(separator) };
}
//# sourceMappingURL=hashDataEncoding.js.map